import React from 'react';
import { FaTh, FaMagnet, FaTrash, FaRedo, FaFont, FaImage, FaShapes, FaQrcode, FaCog } from 'react-icons/fa';
import { MdGridOn, MdGridOff } from 'react-icons/md';
import useEditorStore from '../../store/editorStore';
import { blockTypes } from '../../config/constants';
import './Toolbar.css';

function Toolbar() {
  const { 
    clearCanvas, 
    grid, 
    toggleGrid, 
    toggleSnap,
    addBlock,
    selectedBlockId,
    selectedSectionId,
    togglePropertiesPanel,
    showPropertiesPanel
  } = useEditorStore();

  const handleAddBlock = (type) => {
    if (selectedBlockId || selectedSectionId) return; // Prevent adding if block or section is selected
    // Add block at center of view (approximate)
    addBlock(type, { x: 100, y: 100 });
  };

  const handleDragStart = (e, type) => {
    if (selectedBlockId || selectedSectionId) {
      e.preventDefault();
      return;
    }
    e.dataTransfer.setData('blockType', type);
    e.dataTransfer.effectAllowed = 'copy';
  };

  return (
    <div className="left-sidebar">
      <div className="sidebar-section">
        <h3 className="sidebar-title">เพิ่มวัตถุ (Insert)</h3>
        <div className="tool-group">
          <button 
            className={`tool-item ${selectedBlockId || selectedSectionId ? 'disabled' : ''}`}
            onClick={() => handleAddBlock(blockTypes.TEXT)}
            draggable={!selectedBlockId && !selectedSectionId}
            onDragStart={(e) => handleDragStart(e, blockTypes.TEXT)}
            title={selectedBlockId || selectedSectionId ? "กรุณาคลิกพื้นที่ว่างเพื่อยกเลิกการเลือกก่อน" : "เพิ่มข้อความ (ลากวางได้)"}
            disabled={!!selectedBlockId || !!selectedSectionId}
          >
            <div className="tool-icon">
              <FaFont />
            </div>
            <span className="tool-label">Text</span>
          </button>

          <button 
            className={`tool-item ${selectedBlockId || selectedSectionId ? 'disabled' : ''}`}
            onClick={() => {
              if (selectedBlockId || selectedSectionId) return;
              const input = document.createElement('input');
              input.type = 'file';
              input.accept = 'image/*';
              input.onchange = (e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (event) => {
                    // We need a way to pass the image URL to addBlock or update it immediately
                    // For now, let's just add an image block and let user change it, 
                    // or better, modify addBlock to accept initial content/styles
                    // But since addBlock doesn't support it yet, we'll just add a placeholder
                    // and maybe we can update it right after?
                    // Actually, let's just add the block first.
                    handleAddBlock(blockTypes.IMAGE);
                    // Ideally we would set the image source here.
                    // Let's stick to simple add for now as per request "Freeform elements"
                  };
                  // reader.readAsDataURL(file);
                }
              };
              // input.click(); 
              // For now just add placeholder image block
              handleAddBlock(blockTypes.IMAGE);
            }}
            draggable={!selectedBlockId && !selectedSectionId}
            onDragStart={(e) => handleDragStart(e, blockTypes.IMAGE)}
            title={selectedBlockId || selectedSectionId ? "กรุณาคลิกพื้นที่ว่างเพื่อยกเลิกการเลือกก่อน" : "เพิ่มรูปภาพ (ลากวางได้)"}
            disabled={!!selectedBlockId || !!selectedSectionId}
          >
            <div className="tool-icon">
              <FaImage />
            </div>
            <span className="tool-label">Image</span>
          </button>

          <button 
            className={`tool-item ${selectedBlockId || selectedSectionId ? 'disabled' : ''}`}
            onClick={() => handleAddBlock(blockTypes.QRCODE)}
            draggable={!selectedBlockId && !selectedSectionId}
            onDragStart={(e) => handleDragStart(e, blockTypes.QRCODE)}
            title={selectedBlockId || selectedSectionId ? "กรุณาคลิกพื้นที่ว่างเพื่อยกเลิกการเลือกก่อน" : "เพิ่ม QR Code (ลากวางได้)"}
            disabled={!!selectedBlockId || !!selectedSectionId}
          >
            <div className="tool-icon">
              <FaQrcode />
            </div>
            <span className="tool-label">QR Code</span>
          </button>
        </div>
      </div>

      <div className="sidebar-divider" />

      <div className="sidebar-section mobile-only">
        <h3 className="sidebar-title">ตั้งค่า</h3>
        <div className="tool-group">
          <button 
            className={`tool-item ${showPropertiesPanel ? 'active' : ''}`}
            onClick={togglePropertiesPanel}
            title="ตั้งค่าคุณสมบัติ"
          >
            <div className="tool-icon">
              <FaCog />
            </div>
            <span className="tool-label">Props</span>
          </button>
        </div>
      </div>

      <div className="sidebar-section">
        <h3 className="sidebar-title">เครื่องมือ (Tools)</h3>
        
        <div className="tool-group">
          <button 
            className={`tool-item ${grid.visible ? 'active' : ''}`}
            onClick={toggleGrid}
            title={grid.visible ? "ซ่อนเส้นตาราง" : "แสดงเส้นตาราง"}
          >
            <div className="tool-icon">
              {grid.visible ? <MdGridOn /> : <MdGridOff />}
            </div>
            <span className="tool-label">Grid</span>
          </button>

          <button 
            className={`tool-item ${grid.snapEnabled ? 'active' : ''}`}
            onClick={toggleSnap}
            title="Snap to Grid"
          >
            <div className="tool-icon">
              <FaMagnet />
            </div>
            <span className="tool-label">Snap</span>
          </button>
        </div>
      </div>

      <div className="sidebar-divider" />

      <div className="sidebar-section">
        <h3 className="sidebar-title">การจัดการ (Actions)</h3>
        <div className="tool-group">
          <button 
            className="tool-item danger"
            onClick={() => {
              if(window.confirm('ต้องการล้างข้อมูลทั้งหมดใช่หรือไม่?')) {
                clearCanvas();
              }
            }}
          >
            <div className="tool-icon">
              <FaTrash />
            </div>
            <span className="tool-label">ล้างข้อมูล</span>
          </button>
        </div>
      </div>

      <div className="sidebar-footer">
        <div className="version-info">v1.0.0</div>
      </div>
    </div>
  );
}


export default Toolbar;
